// import http from '../lib/http';

// export const getCategories = () => http.get('/api/customer/categories');





import http from '../lib/http';


export const getCategories = () => http.get('/api/customer/categories'); 
